import { FormEvent, useState } from "react";
import { CheckCircle2, Mail, Send } from "lucide-react";
import { apiSend } from "../services/api";

export function NewsletterBox() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "saving" | "saved" | "error">("idle");

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (!email.trim()) return;
    setStatus("saving");
    try {
      await apiSend("/api/newsletter/subscribe", {
        method: "POST",
        body: JSON.stringify({ email: email.trim(), source: "homepage_digest" })
      });
      setStatus("saved");
      setEmail("");
    } catch {
      setStatus("error");
    }
  }

  return (
    <section className="mag-newsletter-dispatch" aria-labelledby="newsletter-title">
      <div className="mag-newsletter-inner">
        <div className="mag-newsletter-content">
          <div className="mag-newsletter-kicker">
            <Mail size={14} className="text-amber-400" />
            <span>THE ZIMSMART INTELLIGENCE BRIEF</span>
          </div>
          <h2 id="newsletter-title" className="mag-newsletter-heading">
            Essential journalism on Zimbabwean innovation & commerce.
          </h2>
          <p className="mag-newsletter-desc">
            Join 24,000+ business leaders, technologists, policy shapers, and investors receiving our daily 7:00 AM dispatch. Zero spam, uncompromised analysis.
          </p>
        </div>

        <div className="mag-newsletter-action">
          {status === "saved" ? (
            <div className="mag-newsletter-success">
              <CheckCircle2 size={24} className="text-emerald-400" />
              <div>
                <strong>You're on the list!</strong>
                <p>Check your inbox for our latest digital issue and market briefings.</p>
              </div>
            </div>
          ) : (
            <form onSubmit={submit} className="mag-newsletter-form">
              <div className="mag-input-group">
                <Mail size={18} className="mag-input-icon" />
                <input
                  id="newsletter-email-input"
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Enter your work or personal email..."
                  required
                />
              </div>
              <button type="submit" disabled={status === "saving"} className="mag-subscribe-btn">
                <Send size={16} />
                <span>{status === "saving" ? "Subscribing..." : "Get Free Dispatch"}</span>
              </button>
            </form>
          )}
          {status === "error" && (
            <p className="mag-newsletter-err" role="alert">
              Unable to subscribe right now. Please verify your email and try again.
            </p>
          )}
          <p className="mag-newsletter-privacy">
            By subscribing, you agree to our <a href="/privacy">Privacy Policy</a>. Unsubscribe anytime with 1 click.
          </p>
        </div>
      </div>
    </section>
  );
}
